import React from 'react';
import Divider from '../components/Divider';
import HomeSlider from '../components/HomeSlider';
import Parallax from '../components/Parallax';
import ServiceSection from '../components/ServiceSection';
import Testimonial from '../components/Testimonial';
import TopThreeBlock from '../components/TopThreeBlock';

export default class Home extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            pageLoaded: false,
        };
    }

    pageLoaded = (status) => {
        this.setState({
            pageLoaded: status,
        });
    };

    render() {
        return (
            <div>
                <HomeSlider />
                <TopThreeBlock />
                <div
                    className="section"
                    style={{
                        paddingTop: '60px',
                        paddingBottom: '40px',
                        borderTop: '1px solid #eee',
                        borderBottom: '1px solid #eee',
                        background: '#fff',
                    }}
                >
                    <div className="container">
                        <div
                            className="big-title text-center animated fadeInDown delay-01"
                            data-animation="fadeInDown"
                            data-animation-delay="01"
                        >
                            <h1 className="iwh-title">
                                Nos{' '}
                                <span className="accent-color">
                                    prestations{' '}
                                </span>
                            </h1>
                        </div>
                        <p className="text-center" style={{ fontSize: '20px' }}>
                            Optimisez vos ressources, pilotez votre activité et
                            augmentez votre productivité grâce à nos
                            prestations&nbsp;:
                        </p>
                    </div>
                </div>
                <ServiceSection />
                <Parallax pageLoaded={this.state.pageLoaded} />
                <Divider />
                <Testimonial callback={this.pageLoaded} />
                <Divider />
            </div>
        );
    }
}

Home.propTypes = {};



// WEBPACK FOOTER //
// ./src/routes/Home.jsx